export default {
  //授课举手
  SKInteractList: '',
  //举手添加
  SKInteractAdd: '',
  //举手查询
  SKInteractQuery: '',
  //举手结束
  SKInteractOver: '',
  //举手结果
  SKInteractRes: '',
  //举手编辑
  SKInteractEdit: '',
}
